module.exports = __webpack_public_path__ + "img/main-sm.38dfe7d4.jpg";